<template>
  <div class="mobile-not-supported">
    <img
      src="@/assets/datapeople-logo.svg"
      width="159px"
      height="32px"
      class="image"
      alt="Datapeople icon"
    >
    <h4 class="title-message">
      Unfortunately, we are not
      <br> supporting small resolution
      <br> mobile devices.
    </h4>
    <h4 class="supporting-message">
      Please consider using
      <br> <span class="datapeople-app">Datapeople App</span> on
      <br> Desktop/Web setup.
    </h4>
    <span
      class="link"
      @click="continueToUse"
    >Continue to use on mobile</span>
  </div>
</template>

<script>
import { useAppAllowMobile } from '@/stores/app/allowMobile';
import { mapActions } from 'pinia';

export default {
  name: 'MobileNotSupported',
  emits: ['track-page-load'],
  mounted() {
    this.$emit('track-page-load', { page: 'MobileNotSupported' });
  },
  methods: {
    ...mapActions(useAppAllowMobile, ['allowMobile']),
    continueToUse() {
      this.allowMobile();
      this.$router.replace({ name: 'root' });
    },
  },
};
</script>

<style lang="less" scoped>
.mobile-not-supported {
  width: 100%;
  height: 100%;
  background: url('@/assets/App-Gate-BG.jpg');
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.image {
  margin-top: 20%;
}

.title-message {
  font-weight: 500;
  margin-top: 48px;
  max-width: calc(100% - 40px);
}

.supporting-message {
  font-weight: 400;
  margin-top: 48px;
  max-width: calc(100% - 40px);
}

.datapeople-app {
  color: @text-brand;
}

.link {
  margin-top: 48px;
  cursor: pointer;
}
</style>
